import { render, staticRenderFns } from "./TravelSelect.vue?vue&type=template&id=04a5c0f8"
import script from "./TravelSelect.vue?vue&type=script&lang=ts"
export * from "./TravelSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports